module.exports = __webpack_public_path__ + "img/traffic-junction-7.d73d417d.jpg";